import { Knapp } from '../innboks/Detalj.tsx';
import { Ikon } from '../status/Ikon.tsx';

/**
 * Foten på Innstillinger og Organisasjon (DD-58). Festet nederst, ÉTT primærvalg:
 * «Lagre N endringer» med Ctrl+S. Sperret bærer grunnen som setning ved siden av —
 * aldri en grå knapp uten tekst. «Forkast» er tekstknapp og tømmer utkastet for DENNE
 * siden (én nøkkel per side, P3).
 *
 * Foten finnes IKKE for behandler og leser: de har ingenting å lagre. Under 900 px står
 * den i tommelsonen, og knappene tar bredden (konseptets skjerm 6).
 */
export function Fot({ antall, endretNavn, lagrer, feil, sperret = null, onLagre, onForkast, onLukkFeil }: { antall: number; endretNavn: string[]; lagrer: boolean; feil: string | null; /** Utkastet kan ikke lagres som det står — grunnen står ved knappen (forklarte låser). */ sperret?: string | null; onLagre: () => void; onForkast: () => void; onLukkFeil: () => void }) {
  // Knappen sier hva som lagres; grunnen ved siden av sier hvorfor den ikke kan trykkes nå —
  // «Lagrer …» står ett sted, ikke to (DD-67: samme opplysning ett sted).
  const label = antall === 0 ? 'Lagre' : antall === 1 ? 'Lagre 1 endring' : `Lagre ${antall} endringer`;
  return (
    <>
      {feil ? (
        <p role="alert" className="panel-melding panel-melding-feil panel-innst-lagrefeil" data-testid="lagre-feil">
          <Ikon navn="warning-outline" /> {feil}
          <button type="button" className="panel-knapp-liten" onClick={onLukkFeil}>
            Lukk
          </button>
        </p>
      ) : null}
      <footer className="panel-innst-fot" data-testid="innst-fot">
        <Knapp label={label} kbd="Ctrl+S" primaer grunn={lagrer ? 'Lagrer …' : antall === 0 ? 'Ingen endringer ennå' : sperret} onClick={onLagre} testid="lagre" />
        {antall > 0 ? (
          <button type="button" className="panel-knapp-lenke" onClick={onForkast} data-testid="forkast">
            Forkast
          </button>
        ) : null}
        {/* Foten sier HVA som lagres, med radenes navn — aldri feltnavn (DD-50). */}
        {antall > 0 ? <span className="panel-innst-fot-hva">{endretNavn.join(' og ')}</span> : null}
      </footer>
    </>
  );
}
